import { PaintColor } from "@omni/types/api/paintColors/bff/paintColor.model";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { Mapped } from "@omni/utils/context/mapped.context";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, use } from "react";

type ColorListContextValue = {
    family: {
        id: string;
        name: string;
        hex: string;
    };
    colors: Array<PaintColor>;
};

type ColorListContextProviderProps = RequireChildrenFor<{
    family: {
        id: string;
        name: string;
        hex: string;
    };
    colors: Array<PaintColor>;
}>;

export const ColorListContext = createContext<
    ColorListContextValue | undefined
>(undefined);
ColorListContext.displayName = "ColorListContext";

export const ColorListContextProvider = ({
    family,
    colors,
    children
}: ColorListContextProviderProps) => {
    return (
        <ColorListContext
            value={{
                family: family,
                colors: colors
            }}
        >
            <Mapped
                array={colors}
                getKey={(color) => color.id}
            >
                {children}
            </Mapped>
        </ColorListContext>
    );
};

export const useColorListContext = () => {
    const context = use<ColorListContextValue | undefined>(ColorListContext);

    if (!isDefined(context)) {
        throw new Error(`${ColorListContext.displayName} is undefined.`);
    }

    return context;
};
